<template>
	<div class="order_payment">
		<div class="card">
			<div class="title">{{isBatchFeePay?'增加费用合并支付':type=='addMoney'?(isWorkerInscreasePay?'费用调整':'增加费用'):'订单支付'}}</div>
			<div v-if="detailLoading" class="payment-summary-placeholder" role="status">正在加载订单信息…</div>
			<div v-else-if="detailLoadFailed" class="payment-summary-placeholder" role="status">订单信息加载失败，请刷新重试</div>
			<div v-else class="base">
				<div class="header">
					<div class="left">
						<div class="name">{{title}}</div>
						<div class="status">状态：<span class="error">{{status_name}}</span></div>
					</div>
					<div class="right">
						<!--            <Button type="primary" size="small">修改订单</Button>-->
						<Button class="cancel" size="small" v-if="status >= 1 && status <= 6" @click="cancel()">取消订单</Button>
					</div>
				</div>
				<div class="info">
					<span>客户：{{nickname}}</span>
					<span>订单编号：{{order_no}}</span>
					<span>下单时间：{{created_at}}</span>
					<span v-if="end_date != ''">支付截止时间：{{end_date}}</span>
				</div>
			</div>
		</div>
		<div class="block"></div>
		<el-tabs v-show="type==''">
			<el-tab-pane>
				<span slot="label">支付信息</span>
				<div class="block"></div>
				<div class="user-info">
					<el-descriptions title="支付信息" :column="1">
						<el-descriptions-item label="订单费用" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{all_money||0}}
						</el-descriptions-item>
						<el-descriptions-item label="运费" label-class-name="descriptions-label"
							content-class-name="descriptions-label">{{logistics.freight||0}}
						</el-descriptions-item>
						<el-descriptions-item label="优惠券" v-if="formItem.coupon_price>0"
							label-class-name="descriptions-label"
							content-class-name="descriptions-label">-{{formItem.coupon_price||0 }}
						</el-descriptions-item>
						<el-descriptions-item label="最终费用" label-class-name="descriptions-label"
							content-class-name="descriptions-label"> <span class='text-red'>{{price||0}}</span>
						</el-descriptions-item>
					</el-descriptions>
				</div>

			</el-tab-pane>
		</el-tabs>
		<div class="block"></div>
		<div class="padding" v-if="isBatchFeePay">
			<el-table :data="batchFees" row-key="id" v-loading="batchFeesLoading">
				<el-table-column prop="created_at" label="创建时间" min-width="160"></el-table-column>
				<el-table-column prop="instruction" label="原因 / 描述" min-width="240"></el-table-column>
				<el-table-column prop="cost" label="金额（元）" width="140"></el-table-column>
			</el-table>
			<div class="margin-top-sm text-right">共 {{ batchFees.length }} 笔，费用合计：<span class="text-red">{{ batchFeeTotal }}</span> 元</div>
		</div>
		<div class="padding wn60" v-if="type=='addMoney' && !isBatchFeePay">
			<Form class="form" :label-width="80" label-position="left">
				<FormItem label="服务费用:">
					<Input type="number" v-model="fromServer.serverMoney" maxlength="8" :readonly='disabled'></Input>
				</FormItem>
				<FormItem label="说明:">
					<Input class="input" maxlength="50" :rows="3" :readonly='disabled' type="textarea"
						v-model="fromServer.desc" placeholder="请输入简单的标注说明"></Input>
				</FormItem>
				<div class="text-red text-df">
					注意事项：费用支付成功后师傅会收到付款提醒，或者您可以主动告知师傅
				</div>
			</Form>
		</div>
		<div class="btn-grounp" style="padding: 20px;">
			<Form class="form" label-position="top">
				<FormItem label="可用优惠券：" v-if="type!='addMoney'">
					<div class="tab-item" :class="{active:selectedCouponIndex === index}"
						v-for="(item,index) in couponList" :key="index" @click="chooseCoupon(item, index)">
						优惠 {{ item.reduction_money }}元
					</div>
				</FormItem>
				<FormItem label="支付方式：">
					<tabNav :list="payTypeList" v-model="formItem.method"></tabNav>
				</FormItem>
				<FormItem label="支付密码：" v-if="formItem.method=='balance'">
					<Input type="password" maxlength="6" v-model="formItem.password" class="wn60" hidden
						autocomplete="new-password"></Input>
				</FormItem>
				<div class="footer">
					<Button class="pay-btn" type="primary" :loading="checkingFeePayment" :disabled="isBatchFeePay ? (batchFeesLoading || !batchFees.length || batchFees.length !== batchFeeIds.length) : (isWorkerInscreasePay && !addid)" @click="payment()" style="width: 100px">{{isBatchFeePay?'同意并支付':'立即支付'}}</Button>
				</div>
			</Form>
		</div>
	</div>
</template>

<script>
import { EventBus } from '@/utils/event-bus.js'
import HeaderComponents from '../../../components/header'
import MasterItem from './components/master-item'
import cancelOrder from '../../../components/cancel-order'
import tabNav from '../../../components/tabNav'

export default {
  name: 'order_detail',
  components: {
    HeaderComponents,
    MasterItem,
    tabNav
  },

  activated () {
    this.stopWechatPayment()
    let vm = this
    let id = this.$route.params.id
    let addid = this.$route.params.addid || ''
    this.formItem.password = ''
    this.selectedCouponIndex = -1
    this.formItem.coupon_id = ''
    this.formItem.coupon_price = 0
    this.type = this.$route.query.type || this.$route.params.type || ''
    const feeIds = this.$route.query.feeIds
    this.isBatchFeePay = this.type === 'addMoney' && feeIds !== undefined
    this.batchFeeIds = Array.from(new Set((Array.isArray(feeIds) ? feeIds : [feeIds]).filter(value => /^\d+$/.test(String(value)) && Number(value) > 0).map(String)))
    this.batchFees = []
    this.batchFeesLoading = this.isBatchFeePay
    this.checkingFeePayment = false
    this.isWorkerInscreasePay = !this.isBatchFeePay && this.type === 'addMoney' && (String(this.$route.params.fromWorkerInscrease || '') === '1' || !!addid)
    this.disabled = this.isWorkerInscreasePay
    vm.id = id
    vm.addid = ''
    vm.fromServer.serverMoney = ''
    vm.fromServer.desc = ''
    vm.getpwdInfo()
    vm.getCouponList()
    vm.getDetailInfo()
  },
  deactivated () {
    this.stopWechatPayment()
  },
  beforeDestroy () {
    this.stopWechatPayment()
  },
  data () {
    return {
      formItem: {
        method: 'balance',
        money: '',
        coupon_id: '',
        coupon_price: 0,
        password: ''
      },
      disabled: false, // 是否限制输入
      couponList: [], // 可以优惠券
      selectedCouponIndex: -1,
      fromServer: {
        serverMoney: '',
        desc: ''
      }, // 增加服务费
      all_money: '', //
      payTypeList: [{
        value: 'balance',
        label: '余额支付'
      },
      {
        value: 'wechatpc',
        label: '微信支付'
      },
      {
        value: 'apliypc',
        label: '支付宝支付'
      }
      ],
      step: 1,
      timer: null,
      wechatPayment: null,
      checkingFeePayment: false,
      isBatchFeePay: this.$route.query.type === 'addMoney' && this.$route.query.feeIds !== undefined,
      batchFeeIds: [],
      batchFees: [],
      batchFeesLoading: false,
      order_type: 1,
      is_set: '', // 是否设置密码
      type: this.$route.query.type || this.$route.params.type || '', // 首次渲染即使用目标支付模式
      isWorkerInscreasePay: false,
      id: 0, // 订单id
      addid: '', // 增加费用单条id
      worker_id: 0,
      initial_price: 0,
      price: 0,
      offer_data: [],
      offer_all: 0,
      order_no: '',
      status_name: '',
      detailLoading: true,
      detailLoadFailed: false,
      end_date: '',
      status: 0,
      nickname: '',
      title: '',
      created_at: '',
      logistics: {
        has: true,
        address: '',
        arrive: '',
        freight: 0,
        logistics_number: '',
        package_number: '',
        phone: '',
        company: ''
      },
      other: {
        contact: '',
        hope_complete: ''
      },
      address: {
        name: '',
        address: '',
        floor: '',
        phone: '',
        third: ''
      },
      data: [{
        img: '',
        type: 'AM12312312',
        category: '盖板/普通',
        count: 1,
        sku_name: '嵌入式（壁挂）',
        requirement: '不要敲门',
        install: '需要拆除（玻璃胶）'
      }]
    }
  },
  computed: {
    batchFeeTotal () {
      return (this.batchFees.reduce((sum, fee) => sum + Math.round(Number(fee.cost) * 100), 0) / 100).toFixed(2)
    }
  },
  methods: {
    getSelectedPendingFees (list, ids) {
      if (!Array.isArray(list) || !ids.length) return []
      const selected = ids.map(id => list.find(fee => fee && String(fee.id) === id))
      if (selected.some(fee => !fee || String(fee.status) !== '0' || String(fee.is_refund) !== '0' || !Number.isFinite(Number(fee.cost)) || Number(fee.cost) <= 0)) return []
      return selected
    },
    async payBatchFees () {
      if (this.checkingFeePayment || this.batchFeesLoading) return
      if (this.wechatPayment) return this.$message.info('请先完成或关闭当前扫码支付')
      if (!this.batchFees.length || this.batchFees.length !== this.batchFeeIds.length) return this.$message.warning('请返回订单重新选择待付款费用')
      const method = this.formItem.method
      if (method === 'balance' && String(this.is_set) !== '1') {
        this.$message.warning('请先设置支付密码')
        this.$router.push({ name: 'user_setPayPassword' })
        return
      }
      if (method === 'balance' && !this.formItem.password) return this.$message.error('请输入支付密码')
      const orderId = this.id
      const ids = this.batchFeeIds.slice()
      const isCurrent = () => this.$route.name === 'order_pay' && this.isBatchFeePay && String(this.id) === String(orderId) && JSON.stringify(this.batchFeeIds) === JSON.stringify(ids)
      this.checkingFeePayment = true
      try {
        const latest = await this.$request('6120ad9af2b9b', { order_id: String(orderId) })
        if (!isCurrent()) return
        const fees = this.getSelectedPendingFees(latest && latest.data && latest.data.data && latest.data.data.order_inscrease, ids)
        if (!fees.length) {
          this.batchFees = []
          return this.$message.warning('所选费用已处理或不存在，请返回订单重新选择')
        }
        const changed = fees.some((fee, index) => Number(fee.cost) !== Number(this.batchFees[index].cost) || String(fee.instruction || '') !== String(this.batchFees[index].instruction || ''))
        this.batchFees = fees
        if (changed) return this.$message.warning('费用信息已更新，请核对后重新支付')
        if (method === 'apliypc') {
          for (const fee of fees) {
            await this.$request('612c887274100', {
              order_id: String(orderId),
              id: String(fee.id),
              pay_method: 'alipay',
              instruction: fee.instruction || '',
              cost: fee.cost
            })
            if (!isCurrent()) return
          }
          this.startAlipayPayment('https://api.yibxj.com/api/payOrderByAlipay?order_no=' + orderId)
          return
        }
        const payload = { order_id: Number(orderId), ids, pay_method: method === 'apliypc' ? 'alipay' : method }
        if (method === 'balance') payload.password = this.formItem.password
        const res = await this.$request('690000000031', payload)
        if (!isCurrent()) return
        const responseCode = Number(res && res.data && res.data.code)
        if (!res || !res.data || (responseCode !== 0 && responseCode !== 1)) return this.$message.error((res && res.data && res.data.msg) || '支付请求失败，请稍后重试')
        this.formItem.password = ''
        if (method === 'balance') {
          this.$message.success('支付成功')
          this.$router.push({ name: 'order_detail', params: { id: orderId }, hash: '#payment-list' })
        } else if (method === 'wechatpc') {
          this.startWechatPayment(res.data.data)
        } else {
          const data = res.data.data || {}
          const url = data.pay_url || data.url || (data.alipay && (data.alipay.pay_url || data.alipay.url))
          if (typeof url !== 'string' || !/^https?:\/\//i.test(url)) {
            return this.$message.error('未收到有效的支付宝支付链接，请联系平台确认')
          }
          // 使用接口返回的合并支付链接，不以原订单 ID 拼接单笔支付链接。
          this.startAlipayPayment(url)
        }
      } catch (error) {
        if (isCurrent()) this.$message.error('支付未确认成功，请刷新费用状态后重试')
      } finally {
        if (isCurrent()) this.checkingFeePayment = false
      }
    },
    stopWechatPayment () {
      clearTimeout(this.timer)
      this.timer = null
      const payment = this.wechatPayment
      this.wechatPayment = null
      if (payment) payment.dialog.close()
    },
    startAlipayPayment (url) {
      window.open(url, '_blank')
      setTimeout(() => {
        this.$confirm('确定支付成功了吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({ name: 'order_list' })
        }).catch(() => {})
      }, 1000)
    },
    startWechatPayment (paymentData) {
      this.stopWechatPayment()
      const codeUrl = paymentData && paymentData.wechat && paymentData.wechat.code_url
      // 普通订单未返回 order_no 时，使用订单详情 base.number 查询。
      // 增加费用仍使用本次支付返回的单号，不能查询原订单的付款结果。
      const orderNo = this.type !== 'addMoney' ? this.id : (paymentData && paymentData.order_no)
      if (!codeUrl) {
        this.$message.error('支付信息不完整，请刷新页面后重试')
        return
      }
      const dialog = this.$paymentAlert({ title: '扫码支付', code_url: codeUrl, text: '订单支付' })
      const feeIds = this.isBatchFeePay ? this.batchFeeIds.slice() : (this.isWorkerInscreasePay && this.addid ? [String(this.addid)] : null)
      const payment = { dialog, orderNo: orderNo ? String(orderNo) : '', scene: this.type === 'addMoney' ? 'addmoney' : 'order', batchIds: feeIds, orderId: this.id }
      this.wechatPayment = payment
      dialog.then(() => {
        if (this.wechatPayment === payment) this.stopWechatPayment()
      })
      if (!payment.orderNo) {
        this.$message.warning('暂无法自动确认支付结果，付款后请返回订单列表查看状态')
        return
      }
      this.checkWechatPayment(payment)
    },
    async checkWechatPayment (payment) {
      if (this.wechatPayment !== payment) return
      if (!payment.orderNo) return
      try {
        const resp = await this.$request('619f23ac0f0d0', {
          order_no: payment.orderNo,
          scene: payment.scene
        }, 'post', { silentError: true })
        if (this.wechatPayment !== payment) return
        const data = resp && resp.data && resp.data.data
        const paid = !!data && String(data.status) === '1'
        if (paid) {
          this.stopWechatPayment()
          this.$message.success('支付成功')
          this.$router.push(payment.batchIds ? { name: 'order_detail', params: { id: payment.orderId }, hash: '#payment-list' } : { name: 'order_list' })
          return
        }
      } catch (error) {
        if (this.wechatPayment !== payment) return
        // 后台静默重试，支付确认成功后再提示用户。
      }
      if (this.wechatPayment === payment) {
        this.timer = setTimeout(() => this.checkWechatPayment(payment), 2000)
      }
    },
    getCouponList () {
      this.$request('62b430e1cb941', {
        order_id: this.id + ''
      }).then(res => {
        this.couponList = res.data.data
      })
    },
    getpwdInfo () {
      this.$request('62b292c10b427', {}).then(res => {
        this.is_set = res.data.data.status
      })
    },
    getDetailInfo () {
      let vm = this
      vm.detailLoading = true
      vm.detailLoadFailed = false
      vm.end_date = ''
      this.$request('6120ad9af2b9b', {
        order_id: this.id + '',
        coupon_id: this.formItem.coupon_id
      }).then(res => {
        vm.order_no = res.data.data.base.number
        vm.nickname = res.data.data.base.nickname
        vm.created_at = res.data.data.base.created_at
        vm.status_name = res.data.data.msg
        vm.all_money = res.data.data.all_money
        vm.price = res.data.data.price
        vm.status = res.data.data.status

        if (res.data.data.end_date != '' && res.data.data.end_date != undefined && res.data.data
          .end_date !=
						null) {
          vm.end_date = res.data.data.end_date
        }

        vm.order_type = res.data.data.order_type
        vm.title = res.data.data.title

        vm.address.name = res.data.data.address.name
        vm.address.address = res.data.data.address.address
        vm.address.floor = res.data.data.address.floor
        vm.address.phone = res.data.data.address.phone
        vm.address.third = res.data.data.third

        vm.other.contact = res.data.data.other.contact
        vm.other.hope_complete = res.data.data.other.hope_complete

        if (res.data.data.logistics != null && res.data.data.logistics != undefined && res.data.data
          .logistics !=
						'') {
          vm.logistics.address = res.data.data.logistics.address
          vm.logistics.arrive = res.data.data.logistics.arrive
          vm.logistics.freight = res.data.data.logistics.freight
          vm.logistics.logistics_number = res.data.data.logistics.logistics_number
          vm.logistics.package_number = res.data.data.logistics.package_number
          vm.logistics.company = res.data.data.logistics.company
          vm.logistics.phone = res.data.data.logistics.phone
          vm.logistics.has = true
        } else {
          vm.logistics.has = false
        }
        if (vm.type == 'addMoney' && vm.isWorkerInscreasePay) {
          vm.setWorkerInscreasePayInfo(res.data.data.order_inscrease)
        }
        if (vm.isBatchFeePay) {
          vm.batchFees = vm.getSelectedPendingFees(res.data.data.order_inscrease, vm.batchFeeIds)
          if (!vm.batchFees.length) vm.$message.warning('所选费用已处理或不存在，请返回订单重新选择')
        }
      }).catch(() => {
        vm.detailLoadFailed = true
        if (vm.isBatchFeePay) vm.batchFees = []
      }).finally(() => {
        vm.detailLoading = false
        vm.batchFeesLoading = false
      })
    },
    setWorkerInscreasePayInfo (orderInscrease) {
      if (!this.isWorkerInscreasePay) return
      const list = Array.isArray(orderInscrease) ? orderInscrease : []
      const requestedId = this.$route.params.addid
      const pending = list.find(item => item && String(item.status) === '0' && String(item.is_refund) === '0' &&
        (!requestedId || String(item.id) === String(requestedId)))
      this.addid = ''
      this.fromServer.serverMoney = ''
      this.fromServer.desc = ''
      this.disabled = true
      if (!pending || !pending.id) {
        this.$message.warning('该费用申请已处理或不存在，请返回订单查看')
        return
      }
      this.addid = pending.id || ''
      this.fromServer.serverMoney = pending.cost || ''
      this.fromServer.desc = pending.instruction || ''
      this.disabled = true
    },
    chooseCoupon (item, index) {
      this.selectedCouponIndex = index
      this.formItem.coupon_id = item.coupon_id
      this.formItem.coupon_price = item.reduction_money
      this.getDetailInfo()
    },
    cancel () {
      let vm = this
      this.$cancelOrder({
        id: vm.id
      }).then(res => {
        console.log(res)
        if (res == 'confirm') {
          console.log('----')
          vm.$message.success('取消申请已提交，等待师傅同意')
          location.reload()
        }
      })
    },
    addMoneyPay () {
      let vm = this
      console.log(vm.formItem.method, 'vm.formItem.method')
      if (vm.formItem.method == 'balance') {
        if (this.is_set == 1) {
          if (!vm.formItem.password) {
            return vm.$message.error('请输入支付密码')
          }
          vm.balancePay()
        } else {
          vm.$message.error('请先设置支付密码')
          setTimeout(() => {
            this.$router.push({
              name: 'user_setPayPassword'
            })
          }, 200)
        }
      } else {
        // 微信支付  支付宝支付
        return this.$request('612c887274100', {
          order_id: this.id + '',
          id: this.isWorkerInscreasePay ? String(this.addid) : '', // 师傅申请使用原记录，客户主动加费新建
          pay_method: vm.formItem.method == 'wechatpc' ? 'wechatpc' : 'alipay',
          instruction: this.fromServer.desc,
          cost: this.fromServer.serverMoney
        }).then(res => {
          // this.$message.success("支付成功")
          // location.reload();
          if (vm.formItem.method == 'wechatpc') {
            this.startWechatPayment(res.data.data)
          } else { // 支付宝
            this.startAlipayPayment('https://api.yibxj.com/api/payOrderByAlipay?order_no=' + vm.id)
          }
        })
      }
    },
    // 余额支付
    balancePay () {
      this.$util.throttle(() => {
        this.$request('612c887274100', {
          order_id: this.id + '',
          id: this.isWorkerInscreasePay ? String(this.addid) : '', // 师傅申请使用原记录，客户主动加费新建
          pay_method: 'balance',
          instruction: this.fromServer.desc,
          cost: this.fromServer.serverMoney,
          password: this.formItem.password
        }).then(res => {
          console.log(res, '余额支付')
          if (res.data.code == 1) {
            this.$message.success('支付成功')
            // this.$router.go(-1)
            this.$router.push({
             	name: 'order_list'
            })

            // location.reload();
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }, 2000, true)
    },
    async payment () {
      if (this.checkingFeePayment) return
      if (this.isBatchFeePay) return this.payBatchFees()
      // EventBus.$emit("aMsgOrder", '通知订单列表刷新');
      // return
      let vm = this
      if (vm.type == 'addMoney') {
        if (vm.isWorkerInscreasePay && !vm.addid) {
          return vm.$message.warning('暂无可支付的费用申请，请返回订单查看')
        }
        // 增加费用
        if (!vm.fromServer.serverMoney) {
          return vm.$message.error('请输入要增加的费用')
        }
        if (vm.fromServer.serverMoney <= 0) {
          return this.$message.error('请输入正确的费用金额')
        }
        if ((vm.fromServer.serverMoney + '').split('.') && (vm.fromServer.serverMoney + '').split('.')[1] && (
          vm.fromServer.serverMoney + '').split('.')[1].length > 2) {
          return this.$message.error('请输入正确的费用金额')
        }
        if (!vm.fromServer.desc) {
          return vm.$message.error('请简单输入说明')
        }
        if (vm.isWorkerInscreasePay) {
          const orderId = vm.id
          const feeId = vm.addid
          vm.checkingFeePayment = true
          try {
            const res = await vm.$request('6120ad9af2b9b', { order_id: String(orderId) })
            if (String(vm.id) !== String(orderId) || !vm.isWorkerInscreasePay || String(vm.addid) !== String(feeId)) return
            const data = res && res.data && res.data.data
            if (!data || !Array.isArray(data.order_inscrease)) {
              vm.$message.warning('费用状态暂时无法确认，请稍后重试')
              return
            }
            const fee = data.order_inscrease.find(item => item && String(item.id) === String(feeId))
            if (!fee || String(fee.status) !== '0' || String(fee.is_refund) !== '0') {
              vm.addid = ''
              vm.fromServer.serverMoney = ''
              vm.fromServer.desc = ''
              vm.$message.warning('该费用申请已处理，请返回订单查看')
              return
            }
            if (String(fee.cost) !== String(vm.fromServer.serverMoney) || String(fee.instruction || '') !== String(vm.fromServer.desc)) {
              vm.fromServer.serverMoney = fee.cost
              vm.fromServer.desc = fee.instruction || ''
              vm.$message.warning('费用申请信息已更新，请核对后重新支付')
              return
            }
            await vm.addMoneyPay()
          } catch (error) {
            // 请求失败时不发起支付。
          } finally {
            vm.checkingFeePayment = false
          }
          return
        }
        vm.addMoneyPay()
      } else {
        // 待支付订单支付
        if (vm.formItem.method == 'balance') {
          if (this.is_set == 1) {
            if (!vm.formItem.password) {
              return vm.$message.error('请输入支付密码')
            }
            this.$request('61244fce74769', {
              'order_id': vm.id + '',
              'pay_method': vm.formItem.method,
              'password': vm.formItem.password,
              coupon_id: vm.formItem.coupon_id || 0
            }).then(res => {
              console.log(res, '余额支付')
              if (res.data.code == 1) {
                vm.$message.success('支付成功')
                // this.$router.go(-1)
                this.$router.push({
                  	name: 'order_list'
                })
              } else {
                vm.$message.error(res.data.msg)
              }
            })
          } else {
            vm.$message.error('请先设置支付密码')
            setTimeout(() => {
              this.$router.push({
                name: 'user_setPayPassword'
              })
            }, 200)
          }
        } else if (vm.formItem.method == 'wechatpc') {
          // 微信支付
          this.$request('61244fce74769', {
            'order_id': vm.id + '',
            'pay_method': vm.formItem.method,
            coupon_id: vm.formItem.coupon_id || 0
          }).then(res => {
            this.startWechatPayment(res.data.data)
          })
        } else {
          this.$request('62f9ecf1504fd', {
            'order_no': vm.id + '',
            coupon_id: this.formItem.coupon_id || 0
          }).then(res => {
            // 支付宝支付
            this.startAlipayPayment('https://api.yibxj.com/api/payOrderByAlipay?order_no=' + vm.id)
          })
        }
      }
    },
    gotoPay () {
      console.log('gotoPay')
    }
  }
}
</script>

<style lang="less">
	.order_payment {

		.ivu-steps-title {
			margin-top: 2px;
		}

		.card {
			background-color: #FFFFFF;
			padding: 20px;
			border-radius: 3px;

			.payment-summary-placeholder {
				margin-top: 30px;
				min-height: 64px;
				display: flex;
				align-items: center;
				color: #909399;
				font-size: 14px;
			}

			.base {
				margin-top: 30px;
				min-height: 64px;
				border-radius: 3px;

				.header {
					display: flex;
					justify-content: space-between;
					align-items: center;
					gap: 12px;

					.left {
						display: flex;
						align-items: center;
						flex-wrap: wrap;
						gap: 8px 30px;
						min-width: 0;
					}

					.name {
						overflow-wrap: anywhere;
					}

					.name:empty {
						display: none;
					}

					.right {
						flex-shrink: 0;
					}

					.status {
						margin-left: 0;

						.error {
							color: red;
						}
					}

					.right .cancel {
						margin-left: 10px;
					}
				}

				.info {
					margin-top: 10px;
					display: flex;
					flex-wrap: wrap;
					gap: 8px 40px;

					span {
						overflow-wrap: anywhere;
						min-width: 0;
					}
				}
			}

			.title {
				font-size: 18px;
				color: #333;
				font-weight: 450;
				position: relative;

				&::after {
					content: '';
					position: absolute;
					bottom: -10px;
					left: 0;
					width: 70px;
					height: 3px;
					background-color: #FB9E2F;
				}
			}

		}

		.block {
			height: 10px;
			background-color: #f7f8fa;
		}

		.step {
			padding: 20px;

			.title {
				margin-bottom: 15px;
				color: rgb(51, 51, 51);
				font-size: 18px;
				margin-right: 12px;
			}
		}

		.user-info {
			padding: 20px;
		}

		.descriptions-label {
			color: #333333;
		}

		.el-descriptions__title {
			color: rgb(51, 51, 51);
			font-size: 18px;
			font-weight: normal;
		}

		.error {
			color: red;
		}
	}

	.order_payment .tab-item {
		display: inline-block;
		margin-right: 8px;
		height: 35px;
		padding: 0 15px;
		cursor: pointer;
		background-color: #f7f8fa;
		border-radius: 9px;
		border: none;
		color: rgb(17, 17, 17);
		font-size: 12px;
		line-height: 35px;
	}

	.order_payment .tab-item.active {
		color: #FB9E2F;
		font-weight: 500;
		position: relative;

		&::after {
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0;
			border: 1px solid #FB9E2F;
			border-radius: 9px;
		}
	}
</style>
